import React from 'react'
import PropTypes from 'prop-types'
import { Snackbar } from '@mui/material'
import Alert from '@mui/material/Alert'

const ToastNotification = ({
  open,
  message,
  severity = 'success',
  icon,
  customColor,
  onClose,
  autoHideDuration = 4000,
  anchorOrigin = { vertical: 'bottom', horizontal: 'center' }
}) => {
  return (
    <Snackbar
      open={open}
      autoHideDuration={autoHideDuration}
      onClose={onClose}
      anchorOrigin={anchorOrigin}
    >
      <Alert
        onClose={onClose}
        severity={severity}
        variant='filled'
        icon={icon || undefined}
        style={{
          borderRadius: 12,
          backgroundColor: customColor || undefined,
          color: '#fff',
          fontWeight: 500,
          boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
        }}
      >
        {message}
      </Alert>
    </Snackbar>
  )
}

ToastNotification.propTypes = {
  open: PropTypes.bool.isRequired,
  message: PropTypes.string.isRequired,
  severity: PropTypes.oneOf(['success', 'error', 'warning', 'info']),
  icon: PropTypes.node,
  customColor: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  autoHideDuration: PropTypes.number,
  anchorOrigin: PropTypes.shape({
    vertical: PropTypes.oneOf(['top', 'bottom']),
    horizontal: PropTypes.oneOf(['left', 'center', 'right'])
  })
}

export default ToastNotification
